import { useEffect, useRef } from 'react';
import { ActionItem } from '../components/StepActions';
import { useLocale } from '../context/LocaleContext';

/**
 * Rebuild display copy (title, description, button labels) from fresh originals
 * while preserving completion state. Call from every step page that freezes
 * originalActions into useState.
 */
export function relocalizeActions(prev: ActionItem[], originals: ActionItem[]): ActionItem[] {
  return originals.map((original) => {
    const existing = prev.find((a) => a.id === original.id);
    if (!existing) return original;
    return {
      ...original,
      completed: existing.completed,
    };
  });
}

export function useRelocalizeStepActions(
  originalActions: ActionItem[],
  setActions: React.Dispatch<React.SetStateAction<ActionItem[]>>
): void {
  const { locale, i18nVersion } = useLocale();
  const originalsRef = useRef(originalActions);
  originalsRef.current = originalActions;

  useEffect(() => {
    setActions((prev) => relocalizeActions(prev, originalsRef.current));
  }, [locale, i18nVersion, setActions]);
}
